import React, { useContext, useEffect, useState } from "react"
import { DropDown } from "../../../../../components/dropDown/DropDown"
import { IRepeatParams } from "../../../../../types/dashboard"
import { AppContext } from "../../../../../appContext"
import "./RepeatOptionsForm.css"

interface IRepeatOptionsFormProps{
    repeatParams: IRepeatParams, 
    onChange: (value: IRepeatParams | ((last: IRepeatParams)=> IRepeatParams))=>void,
    numberOfItemsText?: string
}

export const RepeatOptionsForm = ({repeatParams, onChange, numberOfItemsText}: IRepeatOptionsFormProps)=>{
    const {translate} = useContext(AppContext);
    const setRepeatParams = onChange;
    const intervalTypes = ['day', 'week', 'month'];
    
    const defaultNumberOfItemsText = numberOfItemsText || translate('repeat_number_of_sessions');
    const repeatValues = [
        translate('repeat_dont_repeat'), 
        translate('repeat_everyday'), 
        translate('repeat_every_other_day'), 
        translate('repeat_every_week'), 
        translate('repeat_every_two_weeks'), 
        translate('repeat_every_month'), 
        translate('repeat_custom')
    ];

    const [allowCustomRepeat, setAllowCustomRepeat] = useState(false);
    const [selectedRepeatIndex, setSelectedRepeatIndex]= useState(0);

    const handleRepeatSelect = (index: number)=>{
        setAllowCustomRepeat(false);
        setSelectedRepeatIndex(index);
        if (index == 0){
            setRepeatParams({})
        }
        if (index == 1){
            setRepeatParams((last)=>({
                repeat: last?.repeat || 1,
                repeatEvery: 1,
                repeatInterval: "day"
            }))
        }
        if (index == 2){
            setRepeatParams((last)=>({
                repeat: last?.repeat || 1,
                repeatEvery: 2,
                repeatInterval: "day"
            }))
        }
        if (index == 3){
            setRepeatParams((last)=>({
                repeat: last?.repeat || 1,
                repeatEvery: 1,
                repeatInterval: "week"
            }))
        }
        if (index == 4){
            setRepeatParams((last)=>({
                repeat: last?.repeat || 1,
                repeatEvery: 2,
                repeatInterval: "week"
            }))
        }
        if (index == 5){
            setRepeatParams((last)=>({
                repeat: last?.repeat || 1,
                repeatEvery: 1,
                repeatInterval: "month"
            }))
        }
        if (index == 6){
            setAllowCustomRepeat(true)
            setRepeatParams(last=>({
                repeat: last?.repeat || 1,
                repeatEvery: last?.repeatEvery || 1,
                repeatInterval: last?.repeatInterval || "day"
            }))
        }
    }

    useEffect(()=>{
        const sessionData = repeatParams;
        if (!sessionData){
            return;
        }

        if (!sessionData.repeatInterval){
            setSelectedRepeatIndex(0);
            setRepeatParams({});
            return;
        }

        if (sessionData.repeatInterval == "day"
            && sessionData.repeatEvery == 1
            && sessionData.repeat == 1
        ){
            setSelectedRepeatIndex(1);
        } else

        if (sessionData.repeatInterval == "day"
            && sessionData.repeatEvery == 2
            && sessionData.repeat == 1
        ){
            setSelectedRepeatIndex(2);
        } else

        if (sessionData.repeatInterval == "week"
            && sessionData.repeatEvery == 1
            && sessionData.repeat == 1
        ){
            setSelectedRepeatIndex(3);
        } else

        if (sessionData.repeatInterval == "week"
            && sessionData.repeatEvery == 2
            && sessionData.repeat == 1
        ){
            setSelectedRepeatIndex(4);
        } else 

        if (sessionData.repeatInterval == "month"
            && sessionData.repeatEvery == 1
            && sessionData.repeat == 1
        ){
            setSelectedRepeatIndex(5);
        } else

        if (sessionData.repeatInterval){
            setSelectedRepeatIndex(6);
        }

        setRepeatParams({
            repeat: sessionData.repeat,
            repeatEvery: sessionData.repeatEvery,
            repeatInterval: sessionData.repeatInterval
        });
    }, []);

    const numberOfSessionValues = new Array(20).fill(0).map((it, i) => i + 1);
    const handleNumberOfSessions = (index: number)=>{
        setRepeatParams(last=>({...last, repeat: numberOfSessionValues[index]}));
    }

    const selectedNumberOfSessionsIndex = numberOfSessionValues.findIndex(it=>it == repeatParams?.repeat);    
    
    const repeatNumberAsInput = <div className="addSession_formItem_line">
        <span>{translate('repeat_sessions_label')}</span>
        <input className="addSession_input" 
            type="number" 
            value={repeatParams?.repeat} 
            min={1} max={10} step={1} 
            onChange={(e)=>setRepeatParams(last=>({...last, repeat: e.target.valueAsNumber}))}
        ></input>
    </div>;

    const disablingBlockStyle = `addSession_repeatCustom ${allowCustomRepeat ? "" : 'addSession_repeatCustom--inactive'}`;

    return (
        <div className="addSession_formItem_content">
            <DropDown maxHeight={100} values={repeatValues} onSelect={handleRepeatSelect} selectedIndex={selectedRepeatIndex}></DropDown>

            {selectedRepeatIndex !=0 && 
            <div className="addSession_formItem_line">
                <span>{defaultNumberOfItemsText}</span>
                <DropDown 
                    values={numberOfSessionValues}
                    width={45}
                    maxHeight={100}
                    onSelect={handleNumberOfSessions}
                    selectedIndex={selectedNumberOfSessionsIndex == -1 ? 0 : selectedNumberOfSessionsIndex}
                ></DropDown>
            </div>}

            {allowCustomRepeat && 
            <div className="addSession_formItem_line">
                <span>{translate('repeat_every')}</span>
                <input className="addSession_input" 
                    type="number"
                    value={repeatParams.repeatEvery}
                    min={1} max={1000} step={1}
                    onChange={(e)=>setRepeatParams(last=>({...last, repeatEvery: e.target.valueAsNumber}))}
                ></input>
            </div>}

            {allowCustomRepeat &&
            <div className="addSession_formItem_line">
                <span>{translate('repeat_interval')}</span>
                <DropDown className="addSession_selectRepeatInterval" 
                    values={intervalTypes} 
                    onSelect={(index)=>setRepeatParams(last=>({...last, repeatInterval: intervalTypes[index]}))} 
                    selectedIndex={intervalTypes.findIndex(it=>it==repeatParams.repeatInterval)}
                ></DropDown>
            </div>}
        </div>
    )
}